import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'

import { accountManagementBulkAdminRouter } from './routing/accountManagementBulkAdminRouter'
import { accountManagementBulkEditorRouters } from './routing/accountManagementBulkEditorRouters'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { accountManagementBulkAdminAccessControl } from './access-control/accountManagementBulkAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'account-management-bulk',
  totem: {
    // Default IPP tool for this domain's routes; matches the Navigation Entry in the IPP UI.
    tool: 'account-management-bulk-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    admin: [accountManagementBulkAdminRouter, ...accountManagementBulkEditorRouters],
  },
  navigationEntries: [],
  // Single top-level chrome entry for the whole Bulk user & role management area; in-page
  // navigation (see BulkWorkspaceShell) switches between the User/Role use cases and the
  // secondary sections. The entry lands on the User management page.
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.PartnerSettings,
      subNavItems: [
        // Single consolidated entry point — the workspace shell at /admin/bulk hosts the
        // sub-nav (Overview/Users/Roles/Operations/Approvals/Audit). Gated on user-or-role
        // modify; per-kind pages re-gate themselves so a roles-only operator never sees
        // the Users tab as actionable.
        {
          route: 'app-admin-account-management-bulk-overview',
          labelId: 'accountManagementBulkDomain.nav.workspace',
          accessControl: accountManagementBulkAdminAccessControl,
          positionNavV3: 0,
        },
      ],
    },
  ],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
